// This file was automatically generated from appchart.letters.selectAttachments.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appchart.letters.selectAttachments');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.ptdata.letters.attachments');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.letters.selectAttachments.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="select-attachments-section el8MainFormContainer"><div class="select-attachments-nav el8LeftNavContainer el8OverflowAuto"></div><div class="select-attachments-content el8AttachmentContainerWithLeftNav el8OverflowAuto"></div></div><div class="attached-item-section dialogAttachmentBar el8OverflowAuto"><span class="el8AppText el8Bold">Attachments:</span><div class="attachments-list">');
  el8.template.appchart.letters.selectAttachments.attachmentList(soy.$$augmentData(opt_data, {renderEmptyText: true, renderPageCount: false}), output);
  output.append('</div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.letters.selectAttachments.searchBar = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8AlignRight"><div class="apptSearch ml5 mr5"><div class="apptSearchWrap"><input class="w100" type="text" name="search" /></div><a class="clear-search-trigger removeSearch"></a><button class="el8button dialog-buttons search-trigger search"></button></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.letters.selectAttachments.emptyAttachmentList = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<span class="el8AppLightText el8ItalicText">select an item above to add it as an attachment</span>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.letters.selectAttachments.attachmentList = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<ol class="el8AttachmentResults">');
  var aList3514 = opt_data.attachments;
  var aListLen3514 = aList3514.length;
  if (aListLen3514 > 0) {
    for (var aIndex3514 = 0; aIndex3514 < aListLen3514; aIndex3514++) {
      var aData3514 = aList3514[aIndex3514];
      el8.template.appchart.letters.selectAttachments.attachmentElem(soy.$$augmentData(aData3514, {renderPageCount: opt_data.renderPageCount}), output);
    }
  } else {
    if (opt_data.renderEmptyText) {
      el8.template.appchart.letters.selectAttachments.emptyAttachmentList(null, output);
    }
  }
  output.append('</ol>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.letters.selectAttachments.attachmentElem = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li class="attachment-item el8FieldSectionOverflow" data-id="');
  el8.template.appchart.letters.selectAttachments._attachmentKey(opt_data, output);
  output.append('">');
  el8.template.ptdata.letters.attachments.savedAttachmentSummary(opt_data, output);
  output.append((opt_data.isConfidential) ? '<span class="el8ConfidentialAttachment"><span class="el8FeedItemConfidentialIcon"></span><span> Confidential</span></span>' : '');
  if (opt_data.renderPageCount) {
    output.append('<span class="el8LetterPageCount page-count" data-id="');
    el8.template.appchart.letters.selectAttachments._attachmentKey(opt_data, output);
    output.append('"></span>');
  }
  output.append('<a class="remove-attachment el8RemoveAttachmentButton" data-id="');
  el8.template.appchart.letters.selectAttachments._attachmentKey(opt_data, output);
  output.append('">&times;</a></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.letters.selectAttachments._attachmentKey = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.entityId) ? soy.$$escapeHtml(opt_data.entityId) : soy.$$escapeHtml(opt_data.attachmentType));
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.letters.selectAttachments.feedElem = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li id="', soy.$$escapeHtml(opt_data.feedId), '" class="clearBPM"><div class="el8TableListContainer attachment-div ', (opt_data.isAttached) ? 'el8BlueHighlightList' : '', '" data-id=', soy.$$escapeHtml(opt_data.attachment.id), ' _fid="', soy.$$escapeHtml(opt_data.feedItemId), '" ><div class="el8TableListItem el8Clickable" ><div style="display: flex;"><div style="flex: 1;"><input type="checkbox" class="attachment-checkbox" ', (opt_data.isAttached) ? 'checked' : '', '></input>');
  el8.template.ptdata.letters.attachments.clientGeneratedAttachmentSummary(opt_data.attachment, output);
  output.append('</div>', (opt_data.attachment.isConfidential) ? '<div style="display: flex;"><span class="el8FeedItemConfidentialIcon"></span><span style="color: #5B7179;"> Confidential</span></div>' : '', '</div></div></div><div class="el8FeedItemSpacer" style="display:none;"></div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.letters.selectAttachments.groupFeedContainer = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="grouped-nav-feed"></div>');
  if (!opt_sb) return output.toString();
};
